<template>
  <div class="history-chart-wrap">
    <Line v-if="hasData" :data="chartData" :options="options" />
    <p v-else class="empty">Нет данных по истории цен за выбранный период.</p>
  </div>
</template>

<script>
import { Line } from 'vue-chartjs'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
)

const fmt = new Intl.NumberFormat('ru-RU')

export default {
  name: 'PriceHistoryChart',
  components: { Line },
  props: {
    series: { type: Array, default: () => [] },
  },
  setup(props) {
    const hasData = () => Array.isArray(props.series) && props.series.length > 0

    const avg = (entry) => (entry ? entry.avg_volume_with_nds : null)

    const shortDate = (iso) => {
      if (!iso) return ''
      const d = new Date(iso)
      if (Number.isNaN(d.getTime())) return String(iso)
      return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' })
    }

    const chartData = {
      labels: (props.series || []).map((s) => shortDate(s.report_date)),
      datasets: [
        {
          label: 'Тент (реальная ставка)',
          data: (props.series || []).map((s) => avg(s.tent)),
          borderColor: '#2d8a57',
          backgroundColor: '#2d8a57',
          borderWidth: 2.5,
          tension: 0.25,
        },
        {
          label: 'Реф (расчёт)',
          data: (props.series || []).map((s) => avg(s.ref)),
          borderColor: '#9aa6b5',
          backgroundColor: '#9aa6b5',
          borderWidth: 2,
          borderDash: [6, 4],
          tension: 0.25,
        },
        {
          label: 'ISO (расчёт)',
          data: (props.series || []).map((s) => avg(s.iso)),
          borderColor: '#c4ccd8',
          backgroundColor: '#c4ccd8',
          borderWidth: 2,
          borderDash: [2, 3],
          tension: 0.25,
        },
      ],
    }

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      interaction: { mode: 'index', intersect: false },
      plugins: {
        legend: { position: 'bottom' },
        tooltip: {
          callbacks: {
            label: (ctx) => `${ctx.dataset.label}: ${fmt.format(ctx.parsed.y ?? 0)} ₽/км`,
          },
        },
      },
      scales: {
        y: {
          beginAtZero: false,
          ticks: { callback: (v) => `${fmt.format(v)} ₽/км` },
        },
      },
    }

    return { hasData, chartData, options }
  },
}
</script>

<style scoped>
.history-chart-wrap {
  width: 100%;
  height: 400px;
  padding: 4px 0;
  position: relative;
}

.empty {
  margin: 0;
  padding: 24px;
  text-align: center;
  color: #56657a;
}
</style>
